import styled from "@emotion/styled";
import { space } from "@smartsheet/design-tokens";
import { memo } from "react";
import { TypeRampV2 } from "../../../typography";
import { DatePickerDayBox, DatePickerDayBoxProps } from "./DatePickerDayBox";
import { datePickerTheme } from "./datePickerTheme";

// These don't change, so we can memoize them.
export const DatePickerDayOfWeek = memo(
    styled(DatePickerDayBox)<DatePickerDayBoxProps>`
        color: ${({ themeMode }) => datePickerTheme.dayLabelColor(themeMode)};
        font-size: ${({ themeMode }) => datePickerTheme.dayLabelFontSize(themeMode)};
        height: ${space.space60};
    `.withComponent(TypeRampV2)
);

DatePickerDayOfWeek.displayName = "DatePickerDayOfWeek";
